/**
 *
 * @param r Red value, between 0 and 255
 * @param g Green value, between 0 and 255
 * @param b Blue value, between 0 and 255
 * @returns Hue value, between 0 and 360
 */
export const getHue = (r: number, g: number, b: number): number => {
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;

  let hue = 0;
  if (delta === 0) return hue;

  if (max === r) {
    hue = ((g - b) / delta) % 6;
  }
  if (max === g) {
    hue = (b - r) / delta + 2;
  }
  if (max === b) {
    hue = (r - g) / delta + 4;
  }

  hue *= 60;
  if (hue < 0) hue += 360;

  return hue;
};
